module.exports = __webpack_public_path__ + "img/m-hd.2bd94e3d.webp";